import { i18n } from "translate/i18n";

export const whatIsYourFeedback = i18n.t("messages.whatIsYourFeedback");
export const reportError = i18n.t("messages.reportError.reportError");
export const feedback = i18n.t("messages.reportError.feedback");
export const tellUs = i18n.t("messages.reportError.tellUs");
export const whatHappened = i18n.t("messages.reportError.whatHappened");
